import React, {useCallback, useEffect, useState} from 'react';
import I18n from 'app/i18n';
import {useNavigate} from 'react-router-dom';
import {getLinkPath, isGuest} from 'app/utils';
import {linkAndroid, linkIOSDownload} from 'app/utils/app_links';
import FastRegistrationWithEmailContent from 'app/components/auth/FastRegistrationWithEmailContent';
import {navigateGoTo} from 'app/utils/navigate/navigateGoTo';
// @ts-ignore
import SvgLogoEgb from 'images/logos/egb-com-black.svg';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

const WelcomeLanding: React.FC = () => {
    const [pressedButton, setPressedButton] = useState<boolean>(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isGuest()) {
            navigate('/play/bets');
            navigateGoTo(getLinkPath('/play/bets'));
        }
    }, []);

    const onClickRegistration = () => {
        setPressedButton(prevState => !prevState);
    };

    const handleOnClickRegistration = useCallback(() => onClickRegistration(), [onClickRegistration]);

    return <main className={`landing-promo-content welcome${pressedButton ? ' no-scroll' : ''}`}>
        <div className="landing-promo-header">
            <a href={getLinkPath('/')} className="logo-landing-promo">
                <img src={SvgLogoEgb} alt="EGB.com" title="EGB.COM"/>
            </a>
        </div>
        <div className="landing-promo-middle">
            <div className="landing-promo-left">
                <div className="landing-promo-slogan-top">
                    <span className="title-thin">{I18n.t('landing_promo_welcome_title_1')}</span>
                    <span className="title-bold">{I18n.t('landing_promo_welcome_title_2')}</span>
                    <span className="title-thin">{I18n.t('landing_promo_welcome_title_3')}</span>
                </div>
            </div>
            <div className={`landing-promo-center${pressedButton ? ' active' : ''}`}>
                <button
                    className="button-close-registration-landing-promo"
                    onClick={handleOnClickRegistration}
                >
                    <SpriteIcon name="#svg-close" size={{height: 21, width: 21}}/>
                </button>
                <div className="landing-promo-registration">
                    <div className="landing-promo-registration-top">
                        <h2>{I18n.t('about_landing_ladder_game_1')}</h2>
                        <p>{I18n.t('landing_promo_welcome_play_slot')} </p>
                    </div>
                    {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                    {/* @ts-ignore */}
                    <FastRegistrationWithEmailContent redirectUrl={'/'}/>
                </div>
            </div>
            <div className="landing-promo-right">
                <div className="landing-promo-slogan-top">
                    <span className="title-thin">{I18n.t('landing_promo_welcome_title_2_1')}</span>
                    <span className="title-bold">{I18n.t('landing_promo_welcome_title_2_2')}</span>
                    <span className="title-thin">{I18n.t('bonus_landing_ladder_game')}</span>
                </div>
                <div className="landing-promo-slogan-get">
                    <span className="landing-promo-get">{I18n.t('landing_promo_welcome_get')}!</span>
                </div>
            </div>
        </div>
        <div className="landing-promo-footer">
            <div className="landing-promo-content-rules">
                <div className="row">
                    <a
                        className="landing-promo-rules"
                        href={'/public/terms_and_conditions'}
                    >
                        {I18n.t('advertising.terms_conditions')}
                    </a>
                </div>
                <div className="row">
                    <div className="landing-promo-list-app">
                        <a
                            rel="noopener noreferrer"
                            target="_blank"
                            className="item"
                            href={linkIOSDownload()}
                        >
                            <SpriteIcon name="#svg-app_store" className="svg-default"/>
                        </a>
                        <a className="item" href={linkAndroid()}>
                            <SpriteIcon name="#svg-google_play" className="svg-default"/>
                        </a>
                    </div>
                </div>
                <div className="row">
                    <div className="landing-promo-list-payment">
                        <span className="item visa">
                            <SpriteIcon name="visa-icon" className="svg-default" />
                        </span>
                        <span className="item mastercard">
                            <SpriteIcon name="mastercard-icon" className="svg-default" />
                        </span>
                        <span className="item license">
                            <SpriteIcon name="license-icon" className="svg-default" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div className="mobile-button-landing-promo">
            <button
                className="button-registration-landing-promo"
                onClick={handleOnClickRegistration}
            >{I18n.t('user.registration')}</button>
        </div>
    </main>;
};

export default WelcomeLanding;
